import { render, staticRenderFns } from "./gstAdmin.vue?vue&type=template&id=5555cdf1"
import script from "./gstAdmin.vue?vue&type=script&lang=js"
export * from "./gstAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports